import {State} from './reducer';
import _ from 'underscore';

export const inSingleColumn = (plugin: any) => (state: State) => {
	const looseRowCount = Object.keys(state.cells).length;
	if (
		state.columnCount > 1 ||
		(state.columnCount > 0 && looseRowCount) ||
		state.rowCount > 1 ||
		(state.rowCount === 1 && plugin.numColumns > 1)
	) {
		return false;
	}

	const selections = state.cells;
	if (!_.isEmpty(selections)) {
		let selectedColumn = false as string | false;
		const columns = plugin.behavior.columns;
		// Let's go old school so we can break out of the loop when all is lost
		// Not breaking at that point could be disasterous on the broswer as we could have a lot
		// of selections
		for (const key in selections) {
			if (!selections.hasOwnProperty(key)) continue;

			const columnIndex = selections[key][0];
			const column = columns[columnIndex];
			if (!column) return false;

			// Must have only one column
			// Column must match any previous column found
			if (
				selections[key].length === 1 &&
				(selectedColumn === false || selectedColumn === column.name)
			) {
				selectedColumn = column.name;
			}
			// Everything is ruined
			else {
				return false;
			}
		}
		return selectedColumn;
	}

	if (state.columnCount === 1) {
		return state.columns[0];
	}

	return false;
};

export const inSingleRow = (plugin: any) => (state: State) => {
	const looseRowCount = Object.keys(state.cells).length;
	if (
		state.rowCount > 1 ||
		(state.columnCount && plugin.numRows > 1) ||
		(state.rowCount > 0 && looseRowCount)
	) {
		return false;
	}

	const cells = state.cells;

	const {numColumns} = plugin;

	// Check loose selections
	if (!_.isEmpty(cells) && !state.rows.length) {
		const keys = Object.keys(cells);
		let selectedRow = false as number | false;
		// Must have only one row key
		// And that row must have an array with all the column indexes in it
		if (keys.length === 1 && cells[keys[0]].length === numColumns) {
			selectedRow = parseInt(keys[0] as string);
		}
		return selectedRow;
	}

	// Else we must have only 1 row in the row selection
	if (state.rowCount === 1) {
		return state.rows[0];
	}

	return false;
};
